import React from 'react'
import styled from 'react-emotion'
import Helmet from 'react-helmet'

import Section from '../components/section/Section'
import Button from '../components/buttons/Button'
import { SectionTwoCol, SectionColumn } from '../components/section/SectionTwoCol'
import { TwoCol, LeftCol, RightCol, } from '../components/two-col'
import SectionHeader from '../components/section/SectionHeader'
import SectionPreHeader from '../components/section/SectionPreHeader'
import SubHeader from '../components/section/SubHeader'
import CalloutContainer from '../components/CalloutContainer'
import HubspotFormSection from '../components/forms/HubspotFormSection'
import HowItWorks from '../components/main/HowItWorks'

import heroImg from '../assets/how-it-works/how-it-works-hero.jpg'
import step1Img from '../assets/how-it-works/how-it-works-step-1.png'
import step2Img from '../assets/how-it-works/how-it-works-step-2.png'
import step3Img from '../assets/how-it-works/how-it-works-step-3.png'
import step4Img from '../assets/how-it-works/how-it-works-step-4.png'
import dotsRight from '../assets/how-it-works/dots-right.svg'
import dotsLeft from '../assets/how-it-works/dots-left.svg'
import seoHero from '../assets/how-it-works/seo-hero.png'

const Bold = styled.span`
  font-weight: bold;
`

const Dots1 = styled.img`
  display: none;
  position: absolute;
  z-index: 10;
  width: 20vw;
  max-width: 330px;
  bottom: -127px;
  left: 44%;

  @media (min-width: 800px) {
    display: block;
  }
`
const Dots2 = styled.img`
  display: none;
  position: absolute;
  z-index: 10;
  width: 20vw;
  max-width: 330px;
  bottom: -170px;
  left: 44%;

  @media (min-width: 800px) {
    display: block;
  }
`

const Dots3 = styled.img`
  display: none;
  position: absolute;
  z-index: 10;
  width: 20vw;
  max-width: 330px;
  bottom: -170px;
  left: 44%;

  @media (min-width: 800px) {
    display: block;
  }
`

class FeaturesPage extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <Helmet
          title={'How Whistle Works'}
          meta={[
            { name: 'og:title', content: 'How Whistle Works' },
            { name: 'description', content: 'Working with 10,000 hoteliers to seamlessly connect you to guests via chat and text' },
            { name: 'og:description', content: 'Working with 10,000 hoteliers to seamlessly connect you to guests via chat and text' },
            { name: 'og:image', content: seoHero },
            { name: 'og:type', content: "website" },
            { name: 'og:locale', content: "en_US" },
          ]}
        />
        <TwoCol bgColor={'#18aa7a'}>
          <LeftCol bgColor={'#18aa7a'} skew color="#fff">
            <h1>How Whistle<br/> Works</h1>
            <SubHeader>Guests will love the <Bold>convenience</Bold><br/> You'll love the <Bold>simplicity.</Bold></SubHeader>
            <CalloutContainer align={'left'}>
              <Button secondary to="/schedule" icon>Book A Demo</Button>
            </CalloutContainer>
          </LeftCol>
          <RightCol image bgImgSrc={heroImg} />
        </TwoCol>
        <SectionTwoCol light>
          <SectionColumn>
            <SectionHeader>Step 1</SectionHeader>
            <SubHeader>The Whistle dashboard seamlessly integrates with your Property Management System.</SubHeader>
          </SectionColumn>
          <SectionColumn>
              <img src={step1Img} alt="Integrated with your PMS Software" />
          </SectionColumn>
        </SectionTwoCol>
        <div style={{ position: 'relative'}}>
          <Dots1 src={dotsRight} alt="Next steps" role="image" />
        </div>
        <SectionTwoCol light>
          <SectionColumn>
            <img src={step2Img} alt="Integrated with your Messaging Channels" />
          </SectionColumn>
          <SectionColumn>
            <SectionHeader align="right">Step 2</SectionHeader>
            <SubHeader align="right"> Whistle's platform sends automated or personalized messages through your guests preffered messaging app.</SubHeader>
          </SectionColumn>
        </SectionTwoCol>
        <div style={{ position: 'relative'}}>
          <Dots2 src={dotsLeft} alt="Next steps" role="image" />
        </div>
        <SectionTwoCol light>
          <SectionColumn>
            <SectionHeader>Step 3</SectionHeader>
            <SubHeader>Communicate with guests and staff via video, live chat or 2-way systems.</SubHeader>
          </SectionColumn>
          <SectionColumn>
            <img src={step3Img} alt="Whistle Video Chat" />
          </SectionColumn>
        </SectionTwoCol>
        <div style={{ position: 'relative'}}>
          <Dots3 src={dotsRight} alt="Next steps" role="image" />
        </div>
        <SectionTwoCol light>
          <SectionColumn>
            <img src={step4Img} alt="Collect guest feedback" />
          </SectionColumn>
          <SectionColumn>
            <SectionHeader align="right">Step 4</SectionHeader>
            <SubHeader align="right">Send proactive, timely notifications and requests for feedback from guests even prior to departure. </SubHeader>
          </SectionColumn>
        </SectionTwoCol>
        <Section light>
          <SectionPreHeader align="center">How to Get Started</SectionPreHeader>
          <SectionHeader align="center">3 Steps. 1 Day. Stress Free.</SectionHeader>
          <HowItWorks />
        </Section>
        <HubspotFormSection
          primary
          trackingId={process.env.ADWORDS_TRACKER_LEAD_FORM}
        />
        
      </div>
    )
  }
}
 
export default FeaturesPage;


// WEBPACK FOOTER //
// ./src/pages/how-it-works.js